module.exports = __webpack_public_path__ + "img/bloomsnature.f9ccdade.jpg";